module.exports = __webpack_public_path__ + "static/eleven-warriors-vintage-hat-scarlet-faf7f5d47a1d3ef17cd8ee02bfc5da8a.webp";